import BaseView from "scripts/views/baseView";

import styles from "sharedStyles/changeOrganizationTile.css";
import template from "templates/changeOrganizationTile.hbs";

class ChangeOrganizationTileView extends BaseView {
  constructor(options) {
    super(options);
    this.options = options;
  }

  get className() {
    return styles.container;
  }

  get events() {
    return {
      click: "onClick",
    };
  }

  template() {
    return template({
      styles,
      organization: this.options.organization,
      isActive: this.options.isActive,
      disabled: this.options.isActive ? "disabled" : "",
    });
  }

  render() {
    this.$el.html(this.template());

    return this;
  }

  onClick() {
    this.trigger("click", this.options);
    return false;
  }
}

export default ChangeOrganizationTileView;
